export default "__VITE_ASSET__BfpUpBbr__"